import { Field, InputType, Int, ObjectType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class GetUploadUrlsArgs extends ActionArgs {
  @Field(() => Int)
  count: number

  @Field(() => String)
  extension: string
}

@ObjectType()
export class UploadUrl {
  @Field(() => String)
  id: string

  @Field(() => String)
  uploadUrl: string

  @Field(() => String)
  publicUrl: string

  @Field(() => Date)
  expiresAt: Date
}

export interface IGetUploadUrls extends IAction<UploadUrl[], GetUploadUrlsArgs> {}
